import { useQuery } from "@tanstack/react-query";
import { fetchSingleShipApi } from "@/API/fetchSingleShipApi";
import { ShipDataType } from "@/types/apiTypes";
import { ShowNotification } from "@/components/ShowNotification";

export const useFetchSingleShip = (shipId: string, shipData?: ShipDataType) => {
  return useQuery<ShipDataType, Error>({
    queryKey: ["ship", shipId],
    queryFn: () => {
      if (!shipId) {
        ShowNotification({
          title: "Error",
          message: "Ship ID is required to fetch data.",
          color: "error",
        });
        throw new Error("Ship ID not provided");
      }
      return fetchSingleShipApi(shipId);
    },
    initialData: shipData,
    enabled: Boolean(shipId),
  });
};
